import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_MIDDLE_END_RESTRICT_CLIENTS = defineFcm('middle_end_restrict_clients')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: {
					type: 'boolean',
				},
				mode: {
					type: 'enum',
					values: ['block', 'warn'],
				},
				allowedClients: {
					type: 'array',
					shape: {
						type: 'string',
					},
				},
				minClientVersions: {
					type: 'record',
					shape: {
						type: 'string',
					},
				},
			},
		}),
	)
	.withDefault({
		enabled: false,
		mode: 'block',
		allowedClients: [],
		minClientVersions: {},
	})
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'corgi-middle-end',
		context: 'Middle End',
		description: `Used to restrict possible values for X-Requested-With header in middle end requests.

	This is mostly useful to stop trying to process requests from very old clients (which can result in adding noise to our logs and reported errors).

	"minClientVersions" expects semver versions.

	mode:block - will block requests from clients that do not match the allowedClients or have a version lower than the minClientVersions.
	mode:warn - will log a warning for requests from clients that do not match the allowedClients or have a version lower than the minClientVersions, but will not block the request.

	⚠️ Only global group is supported.`,
		template: {
			enabled: true,
			mode: 'block',
			allowedClients: [
				'corgi-front-end-server',
				'corgi-front-end-browser',
				'change-ios',
				'change-android',
				'change-public-api',
				'graphql-playground',
				'TestCafe',
				'optimizely',
			],
			minClientVersions: {
				'corgi-front-end-server': '0.0.0',
				'corgi-front-end-browser': '0.0.0',
				'change-ios': '0.0.0',
				'change-android': '0.0.0',
			},
		},
	});
